// extracted by mini-css-extract-plugin
export var copyableField = "_ma-4";
export var customerBadge = "_ma-0";
export var customerInfoTitle = "_ma-2";
export var details = "_ma-1";
export var dropdownContainer = "_ma-5";
export var dropdownImage = "_ma-6";
export var editAssigneeForm = "_ma-a";
export var editButton = "_ma-3";
export var email = "_ma-7";
export var hidden = "_ma-d";
export var input = "_ma-8";
export var saveButton = "_ma-b";
export var shopifyIcon = "_ma-c";
export var suggestionBadge = "_ma-e";
export var suggestionText = "_ma-f";
export var username = "_ma-9";